import React from "react";
import { useTheme } from "@mui/material/styles";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import { Container } from "@mui/material";

import initialBackground from "../../images/nakshatra-veda-banner.webp";
import secondBackground from "../../images/nakshatra-aaztha-banner.webp";
import thirdBackground from "../../images/nakshatra-prithvi-banner.webp";
import fourthBackground from "../../images/nakshatra-gokul-banner.webp";
import FifthBackground from "../../images/nakshatra-auris-banner.webp";
import SixthBackground from "../../images/radheshyam-heights-project.webp";
import SeventhBackground from "../../images/nakshatra-nirvana-banner.webp";

import "../../styles/DesktopHomePage.css";
import { Helmet } from "react-helmet";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
  { url: initialBackground, text: "Nakshatra Veda I & II, Vasai",alt:"Homepage banner of Nakshatra Veda residential project"},
  { url: secondBackground, text: "Aazstha, Vasai",alt:"Banner of Nakshatra Aaztha - premium homes" },
  { url: thirdBackground, text: "Nakshatra Prithvi, Vasai",alt:"Nakshatra Prithvi project showcase" },
  { url: fourthBackground, text: "Nakshatra Gokul, Virar",alt:"Elegant homes at Nakshatra Gokul" },
  { url: FifthBackground, text: "Nakshatra Auris, Nalasopara",alt:"Nakshatra Auris project banner" },
  { url: SixthBackground, text: "Radheshyam Heights, Borivali",alt:"Radheshyam Heights modern residences" },
  { url: SeventhBackground, text: "Nakshatra Nirvaana, Naigaon", alt:"Nakshatra Nirvana main banner" },
  { url: initialBackground, text: "Nakshatra Veda I & II, Vasai",alt:"Homepage banner of Nakshatra Veda residential project" },
  { url: secondBackground, text: "Aazstha, Vasai",alt:"Banner of Nakshatra Aaztha - premium homes"  },
  { url: thirdBackground, text: "Nakshatra Prithvi, Vasai",alt:"Nakshatra Prithvi project showcase"  },
  { url: fourthBackground, text: "Nakshatra Gokul, Virar",alt:"Elegant homes at Nakshatra Gokul"  },
  { url: FifthBackground, text: "Nakshatra Auris, Nalasopara",alt:"Nakshatra Auris project banner" },
  { url: SixthBackground, text: "Radheshyam Heights, Borivali",alt:"Radheshyam Heights modern residences" },
  { url: SeventhBackground, text: "Nakshatra Nirvaana, Naigaon",alt:"Nakshatra Nirvana main banner"},

];

const DesktopHomePage = ({ scrollToSection }) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <div id="home" className="homepage">
      <Helmet>
      <title>
        Top 10 Real Estate Developers in Mumbai | JSB Homemakers
      </title>
              <meta
                name="description"
                content="JSB Homemakers, one of the top 10 real estate developers in Mumbai and among the biggest in India, is offering premium homes. Book your dream property today"
              />
      </Helmet>
      <AutoPlaySwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        interval={5000}
        className="carousel"
        style={{ overflow: "hidden" }}
      >
        {images.map((image, index) => (
          <div
            key={index}
            className="carousel-item"
            style={{
              backgroundImage: `url(${image.url})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <img
              src={image.url}
              // alt={`Slide ${index}`}
              alt={image.alt}
              className="carousel-image"
              loading="lazy"
            />
          </div>
        ))}
      </AutoPlaySwipeableViews>

      <Container className="content">
        <div className="whereQualityMeetsContainer">
          <span className="whereQualityMeetsContainer1">
            <p className="whereQuality">
              <span className="where">Where </span>
              <span>quality</span>
            </p>
            <p className="meetsYourDreams">
              <span>meets your </span>
              <span className="dreams">dreams </span>
            </p>
          </span>
        </div>
        {/* <br /> */}
        <br />
        <div className="text-above-button">
          <p>{images[activeStep].text}</p>
        </div>
        <div className="ctaButtonContainer">
          <button className="enquireButton" onClick={() => scrollToSection()}>
            ENQUIRE NOW
          </button>
        </div>
      </Container>
    </div>
  );
};

export default DesktopHomePage;
